import {useSelector} from "react-redux";
import {decadeConstructor} from "../periodValuesFilterApi";
import React from "react";

export default function DecadeTable({decadeOperations, tableOperations}) {
    const constructor = useSelector(decadeConstructor);
    const filtersRows = constructor.filtersRows;

    const tableStyle = {
        tableLayout: "fixed",
        width: "1350px",
        borderCollapse: "collapse",
        marginBottom: "90px",
        fontFamily: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
    }


    const createTable = () => {

        return (
            <>
                <table border={"1px"} style={tableStyle}>
                    {createHeaders()}
                    {constructor.withoutDays ? <></> : createRows(1, 10)}
                    {createDecadeResultRow(1)}
                    {constructor.withoutDays ? <></> : createRows(11, 20)}
                    {createDecadeResultRow(2)}
                    {constructor.withoutDays ? <></> : createRows(21, 31)}
                    {createDecadeResultRow(3)}
                    {createTableResultRow()}
                </table>
            </>

        );
    }

    const createRows = (from, to)  => {

        return Array.apply(0, Array((to-from) + 1)).map(
            (x,i) => createRow(i+from)
        )

    }

    function calculateColumnsNumForYearAggregate() {
        if (filtersRows.length > 4) return 4
        return filtersRows.length
    }

    function calculateRowsNumber() {
        return decadeOperations.length * 3
            + (tableOperations.length > 0 ? tableOperations.length + 1 : 0)
            + 2
            + (constructor.withoutDays ? 0 : 31)
    }

    function calculateRowsToJoinInAYearBlock() {
        return constructor.withoutDays ?
            decadeOperations.length * 3 :
            decadeOperations.length * 3 + 31
    }

    const createRow = (day) => {
        const monthNumber = calculateMonthColumnsNumber(filtersRows.length)

        return (
            <tr>
                <td align={"center"}>{day}</td>
                {Array.apply(0, Array(monthNumber)).map(function (x,i) {
                    return createFilterColumnsInRow();
                })}
                {
                    filtersRows.length <= 4 && tableOperations.length > 0 ?
                        Array.apply(0, Array(filtersRows.length)).map(
                            (x,i) => <td></td>) : <></>
                }
                {
                    filtersRows.length > 4 && tableOperations.length > 0 ?
                        <>
                            <td align={"center"}></td>
                            <td align={"center"}></td>
                            <td align={"center"}></td>
                            <td align={"center"}></td>
                        </> : <></>
                }
            </tr>
        )
    }

    const createFilterColumnsInRow = () => {
        return Array.apply(0, Array(filtersRows.length)).map(
            (x,i) => <><td></td></>
        );
    };

    const createDecadeResultRow = (decadeNum)  => {
        const monthColumnsNumber = calculateMonthColumnsNumber(filtersRows.length)

        return (
            Array.apply(0, Array(decadeOperations.length)).map((x, i) =>
                <tr>
                    {constructor.withoutDays ? i==0 ? <td align={"center"} rowSpan={decadeOperations.length}>{decadeNum}</td> : <></> : <></>}
                    <td align={"center"}><b>{decadeOperations[i].name}</b></td>
                    {Array.apply(0, Array(monthColumnsNumber)).map(
                        (x,i) => Array.apply(0, Array(filtersRows.length)).map(
                            (x,i) => <td></td>
                        )
                    )}
                </tr>
            )
        )

    }

    const createTableResultRow = ()  => {
        const monthColumnsNumber = calculateMonthColumnsNumber(filtersRows.length)

        return (
            <>
                <tr height='20px'></tr>
                {
                    Array.apply(0, Array(tableOperations.length)).map((x, i) =>
                        <tr>
                            {constructor.withoutDays ? <td></td> : <></>}
                            <td align={"center"}><b>{tableOperations[i].name}</b></td>
                            {Array.apply(0, Array(monthColumnsNumber)).map(
                                (x,i) => Array.apply(0, Array(filtersRows.length)).map(
                                    (x,i) => <td></td>
                                )
                            )}
                            {
                                filtersRows.length <= 4 && tableOperations.length > 0 ?
                                    Array.apply(0, Array(filtersRows.length)).map(
                                        (x,i) => <th></th>) : <></>
                            }
                            {
                                filtersRows.length > 4 && tableOperations.length > 0 ?
                                    <>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </> : <></>
                            }

                        </tr>
                    )
                }
            </>
        )

    }

    const createHeaders = () => {
        const monthColumnsNumber = calculateMonthColumnsNumber(filtersRows.length)

        return <>
            <tr style={{"padding": "0"}} height="20px">
                {
                    constructor.withoutDays ?
                        <>
                            <th rowSpan={2} width={"110px"}>Декада</th>
                            <th rowSpan={2} width={"110px"}>Операция</th>
                            {createMonthHeaderColumns(monthColumnsNumber)}
                            {tableOperations.length > 0 ? <td align={"center"} colSpan={calculateColumnsNumForYearAggregate()}><b>Год</b></td> : ''}
                        </>
                        :
                        <>
                            <th rowSpan="2" width={"110px"}>Число</th>
                            {createMonthHeaderColumns(monthColumnsNumber)}
                            {tableOperations.length > 0 ? <td align={"center"} colSpan={calculateColumnsNumForYearAggregate()}><b>Год</b></td> : ''}
                        </>
                }
            </tr>
            <tr>{createCodesRow(monthColumnsNumber)}</tr>
        </>
    }

    const createCodesRow = (monthColumnsNumber) => {
        return (
            <>
                {Array.apply(0, Array(monthColumnsNumber)).map(
                    (x,i) => Array.apply(0, Array(filtersRows.length)).map(
                        (x,i) => <th width={"80px"}><span>{
                            filtersRows[i].code.code == '' ? '' : 'К-' + (i+1)
                        }</span></th>
                    )
                )}
                {
                    filtersRows.length <= 4 && tableOperations.length > 0 ?
                        Array.apply(0, Array(filtersRows.length)).map(
                            (x,i) => <th width={"80px"}><span>{
                                filtersRows[i].code.code == '' ? '' : 'К-' + (i+1)
                            }</span></th>) : <></>
                }
                {
                    filtersRows.length > 4 && tableOperations.length > 0 ?
                        <>
                            <th width={"80px"}><span>{filtersRows[0].code.code === '' ? '' : 'К-1'}</span></th>
                            <th width={"80px"}><span>{filtersRows[1].code.code === '' ? '' : 'К-2'}</span></th>
                            <th width={"80px"}><span>...</span></th>
                            <th width={"80px"}><span>{filtersRows[filtersRows.length-1].code.code === '' ? '' : 'К-' + filtersRows.length}</span></th>
                        </> : <></>

                }
            </>
        )
    }

    const createMonthHeaderColumns = (monthColumnsNumber) => {
        return (
            <>
                {Array.apply(0, Array(monthColumnsNumber)).map(
                    (x,i) => <th colSpan={filtersRows.length} >{i+1}</th>
                )}
                {
                    filtersRows.length === 1 && tableOperations.length > 0 ?
                        <th rowSpan={calculateRowsNumber()}>...</th> : <></>
                }
                {
                    filtersRows.length > 1 ? <th rowSpan={calculateRowsNumber()}>...</th> : <></>
                }


            </>
        )
    }

    const calculateMonthColumnsNumber = (amountOfFilters) => {
        let result = 12;

        if (amountOfFilters !== 1) {
            const maxColumns = 16;
            let i = 1;

            while (amountOfFilters * i < maxColumns) {
                i += 1;
            }

            result = i;
        }



        if (tableOperations.length === 0 && filtersRows.length > 10) {
            return 1
        }

        if (tableOperations.length !== 0) {
            return result - 1
        }

        return result
    }

    return (
        <div>
            {createTable()}
        </div>
    )
}